import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ConfigModel } from '../../config/config.model';
import { ConfigService } from '../../config/config.service';
import { IpCountry } from '../models/ip-country.model';
import { SecondIpCountry } from '../models/second-ip-country.model';

@Injectable({
  providedIn: 'root'
})
export class IpCountryService {
  protected configModel?: ConfigModel;
  ipCountry:IpCountry
  constructor(private httpClient: HttpClient, protected configService: ConfigService) {
    this.ipCountry = { ip: "N/A", country: "N/A" }
    this.configService.config$.subscribe(configModel => {
      this.configModel = configModel;
    });
  }


  updateIpCountry(): Observable<IpCountry> {
    return this.httpClient.get<IpCountry>(this.configModel?.EndpointServiceIpCountry || "https://ipinfo.io/json");
  }
  updateSecondIpCountry(): Observable<SecondIpCountry> {
    return this.httpClient.get<SecondIpCountry>(this.configModel?.EndpointSecondServiceIpCountry || "https://ipv4.seeip.org/geoip");
  } 

}

